// ─── Roles ──────────────────────────────────────────────────────
export const ROLES = [
	'USER',
	'LEADER',
	'TECHNICIAN',
	'SSMA_MANAGER',
	'MANAGER',
	'ADMIN',
] as const
export type Role = (typeof ROLES)[number]

/** Numeric weight — higher number = more privileges */
export const ROLE_LEVEL: Record<Role, number> = {
	USER: 0,
	LEADER: 1,
	TECHNICIAN: 2,
	SSMA_MANAGER: 3,
	MANAGER: 4,
	ADMIN: 5,
}

// ─── JWT payload (decoded access-token) ─────────────────────────
export interface JwtPayload {
	userId: string
	badge: string
	role: Role
	crId: string | null
	shouldChangePassword: boolean
}

// ─── User profile (returned by /auth/login and /auth/me) ────────
export interface UserProfile {
	userId: string
	personId?: string
	badge: string
	name: string
	jobRole?: string | null
	role: Role
	crId: string
	crName: string | null
	isActive: boolean
	shouldChangePassword: boolean
	lastLoginAt: string | null
}

// ─── Login ──────────────────────────────────────────────────────
export interface LoginRequest {
	registration: string
	password: string
}

export interface LoginResponse {
	user: UserProfile
}

// ─── Refresh ────────────────────────────────────────────────────
export interface RefreshRequest {
	refreshToken: string
}

export interface RefreshResponse {
	accessToken: string
	refreshToken: string
}

// ─── Force change password (first login) ────────────────────────
export interface ForceChangePasswordRequest {
	newPassword: string
}

// ─── Change password (voluntary) ────────────────────────────────
export interface ChangePasswordRequest {
	currentPassword: string
	newPassword: string
}

// ─── Users management (admin) ───────────────────────────────────
export interface UserOutput {
	id: string
	personId: string
	badge: string
	name: string
	role: Role
	crId: string | null
	crName: string | null
	isActive: boolean
	shouldChangePassword: boolean
	lastLoginAt: string | null
	createdAt: string
}

export interface UsersListResponse {
	items: UserOutput[]
	total: number
	page: number
	limit: number
	totalPages: number
}

export interface UsersListParams {
	q?: string
	crId?: string
	role?: Role
	isActive?: 'true' | 'false'
	page?: number
	limit?: number
}

export interface UpdateRoleRequest {
	role: Role
}

export interface UpdateStatusRequest {
	isActive: boolean
}
